<template>
  <div class="pdf-showcase" aria-hidden="true">
    <div class="pdf-stack">
      <!-- Back card: Complex Formula & Value Substitution (IS 800 Cl. 9.3 Combined Axial + Bending Check) -->
      <div class="pdf-card pdf-card-back">
        <img
          src="@/assets/steel-column-formula-back.png"
          alt="Steel Column Design Complex Formula and Value Substitutions"
          class="pdf-img pdf-img-back"
        />
      </div>
      <!-- Front card: Front Page with KPI Pass Status & Design Input Summary (IS 800:2007) -->
      <div class="pdf-card pdf-card-front">
        <img
          src="@/assets/steel-column-kpi-front.png"
          alt="Steel Column Design First Page with KPI Status and Input Parameters"
          class="pdf-img pdf-img-front"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.pdf-showcase {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/*
  Stack container: generous vertical depth to showcase full reports with comfortable clearance.
*/
.pdf-stack {
  position: relative;
  width: 100%;
  max-width: 650px;
  height: 670px;
  margin-top: 12px;
}

.pdf-card {
  background: var(--paper-surface);
  border-radius: var(--radius-control);
  overflow: hidden;
  border: 1px solid color-mix(in srgb, var(--text-primary) 12%, transparent);
  position: absolute;
}

/* Back card: Complex Formula Substitution (IS 800 Cl. 9.3.2.2 Combined Axial + Bending Check) */
.pdf-card-back {
  top: 0;
  right: 0;
  width: 84%;
  height: 380px;
  z-index: var(--z-base);
  box-shadow: var(--shadow-card);
}

.pdf-img-back {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  /* Top starts directly with Cl. 9.3.2.2 and Combined Axial + Bending Check */
  object-position: center top;
}

/* Front card: First Page KPI & Input Summary (Extended depth to use vertical space and show full Applied Loads table) */
.pdf-card-front {
  bottom: 0;
  left: 0;
  width: 88%;
  height: 420px;
  z-index: var(--z-content);
  box-shadow: var(--shadow-hover);
}

.pdf-img-front {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  /* Displays complete header, green PASS status badge, interaction ratio KPI, Section, and Applied Loads table */
  object-position: center top;
}

/* Mobile: front card only */
@media (max-width: 767px) {
  .pdf-stack {
    height: auto;
  }

  .pdf-card-back {
    display: none;
  }

  .pdf-card-front {
    position: relative;
    width: 100%;
    height: auto;
    bottom: auto;
    left: auto;
  }

  .pdf-img-front {
    height: 300px;
    object-position: center top;
    transform: scale(1.02);
    transform-origin: center top;
  }
}
</style>
